export const removeWidgetData = (): void => {
  // Remove local storage entries that don't contain `hawk-${widgetId}` & include `hawk-`
  // These aren't needed anymore, but more importantly we don't want to fill up local storage
  // otherwise widgets won't render
  // We also shouldn't remove local storage entries that we haven't entered
  const keys = Object.keys(window.localStorage).filter((key) => key.indexOf('hawk-') >= 0);
  keys.forEach((key) => delete window.localStorage[key]);
};
